import React from 'react';
import PropTypes from 'prop-types';
import Div from './styles';

const propTypes = {
  children: PropTypes.node.isRequired,
  rounded: PropTypes.bool,
  padding: PropTypes.string,
  margin: PropTypes.string,
  className: PropTypes.string,
  center: PropTypes.bool,
};

function Card({ children, rounded, padding, margin, center, className }) {
  return (
    <Div className={className} rounded={rounded} padding={padding} margin={margin} center={center}>
      {children}
    </Div>
  );
}

Card.propTypes = propTypes;
export default Card;
